/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */

import React from 'react';
import type { Match, RouterHistory } from 'react-router-dom';

import CallUsPage from '../../components/CallUsPage/CallUsPage';
import { iconsAndTitles } from '../../constants';
import {
  CAR_INSURANCE_TYPE,
  TRAVEL_INSURANCE_TYPE
} from '../../constants/insuranceTypeConstants';
import {
  carinsurancePhoneNumber,
  insurancePhoneNumber,
  localTravelInsurancePhoneNumber
} from '../../constants/phoneNumbers';
import { insuranceTypeParameter } from '../../helpers';

const getInsuranceNumber = (type: string) => {
  switch (type) {
    case TRAVEL_INSURANCE_TYPE:
      return localTravelInsurancePhoneNumber;
    case CAR_INSURANCE_TYPE:
      return carinsurancePhoneNumber;
    default:
      return insurancePhoneNumber;
  }
};

const AmendPolicyPage = ({
  match,
  history
}: {
  match: Match,
  history: RouterHistory
}) => {
  const type = insuranceTypeParameter(match);
  return (
    <CallUsPage
      history={history}
      icon={iconsAndTitles[type].icon}
      title="Amend Policy"
      contentText="If you wish to amend your policy please call us on"
      phoneNumber={getInsuranceNumber(type)}
    />
  );
};

export default AmendPolicyPage;
